<script>
import baseList from '@/views/components/base/baseList.vue'
export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: 'notice',
        key: 'id',
        url: {
            del: '/admin/system/notice'
        },
        output: false,
      },
      actions: [
        {
          label: '新增',
          icon: 'md-add',
          onClick: this.toAdd,
          type: "info",
          auth: '',
        },
      ],
      menus: [
        // {
        //   label: "配置列表",
        //   name: "configure_list",
        //   auth: "/admin/configure/lists",
        // },
        // {
        //   label: "坐席列表",
        //   name: "callConfig_list",
        //   auth: "/admin/callConfig/lists",
        // },
        // {
        //   label: "公告列表",
        //   name: 'notice_list',
        //   auth: '/admin/configure/lists',
        // },
        // {
        //   label: "操作日志",
        //   name: "operlog_list",
        //   auth: "/admin/operlog/lists",
        // },
        // {
        //   label: "登录日志",
        //   name: "logininfor_list",
        //   auth: "/admin/logininfor/lists",
        // },

        // {
        //   label: "投诉管理",
        //   name: "feedback_list",
        //   auth: "/admin/feedback/lists",
        // },
      ],
      query: {},
      filters: [{ label: '标题',KeyEnter : this.search, name: 'title', value: '', type: 'input' }],
      tableCols: [
        {
          title: '序号',
          key: 'noticeId',
          width: 80,
          align: 'center',
        },
        // {
        //     title: '发布者',
        //     key: 'user',
        //     align: 'center',
        //     width: 120,
        //     render: (h, params) => {
        //         const row = params.row;
        //         const text = row.user && row.user.user_nick
        //         return h('span', {
        //             style: {
        //                 'font-size': '14px'
        //             }
        //         }, text);
        //     }
        // },
        {
          title: '公告标题',
          key: 'noticeTitle',
          minWidth: 160,
          align: 'center',
        },
        {
          title: '公告内容',
          key: 'noticeContent',
          minWidth: 220,
          align: 'center',
          render: (h, params) => {
            const row = params.row
            const text = row.noticeContent
            return h(
              'span',
              {
                style: {
                  'font-size': '14px',
                },
              },
              text
            )
          },
        },
        // {
        //     title: '排序',
        //     align: 'center',
        //     sortable: 'custom',
        //     key: 'sort',
        //     width: 90,
        //     editable: true
        // },
        {
          title: '创建时间',
          width: 150,
          align: "center",
          key: "createTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.createTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
        {
          title: '操作',
          align: 'center',
          width: 160,
          key: 'handle',
          handle: ['edit', 'delete'],
        },
      ],
    }
  },
  created() {},
  methods: {
    toAdd() {
      $utils.url.push({ name: 'notice_add', query: { action: 'add' } })
    },
    handleEdit(currentRow) {
      let kv = currentRow.id
      $utils.url.push({ name: 'notice_edit', query: { action: 'edit', kv } })
    },
  },
}
</script>
